import { getExpirationTranslation } from './utils';

interface ExpirationBadgeProps {
  inviteExpiration: number;
}

const ExpirationBadge = ({ inviteExpiration }: ExpirationBadgeProps) => (
  <span className="bg-tertiary-50 text-white px-2 py-px rounded-full text-xs leading-normal truncate max-w-fit">
    {getExpirationTranslation(inviteExpiration)}
  </span>
);

export default ExpirationBadge;
